/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import axios from 'axios';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';
// dispatch function for tab data for request current Dispute Display screen
export const dispatchPerformResolutionObj = (data) => ({
  type: actionTypes.GET_CURRENT_DISPLAY_OBJ_UNIT,
  screenData: data,
});

// dispatch Quarter From
export const dispatchQtrRange = (data) => ({
  type: actionTypes.GET_FROM_UNIT,
  payload: data,
});

export const setPaginationIndex = (value) => ({
  type: actionTypes.SET_PAGINATION_INDEX_UNIT_ADJUSTMENT_AT_NDC_LEVEL,
  payload: value,
});

// plan Type dispatch
export const dispatchPlanType = (data) => ({
  type: actionTypes.GET_PLAN_TYPE_DATA_UNIT,
  payload: data,
});
//  error msg dispatch function
export const dispatchErrorMsgUnit = (data) => ({
  type: actionTypes.GET_ERROR_MSG_UNIT,
  payload: data,
});
// error message for 5 sec for no contract exists
export const showNoDataMessage = () => (dispatch) => {
  // setTimeout(() => {
  //   dispatch(dispatchErrorMsgUnit([]));
  // }, 8000);
  dispatch(
    dispatchErrorMsgUnit([
      {
        field: 'noData',
        message: NO_DATA,
      },
    ])
  );
};
// refresh data
export const refreshUnitAdjustment = () => ({
  type: actionTypes.SET_REFRESH_DATA_UNIT,
  payload: {},
});
// dispatch Display screen Object
export const dispatchDisplayUnitAdjustment = (data) => ({
  type: actionTypes.REFRESH_DATA_UNIT_DISPLAY,
  payload: data,
});

export const dispatchDisplayObjAdjustment = (data) => ({
  type: actionTypes.SET_DISPLAY_OBJ_UNIT,
  payload: data,
});
export const setLoading = (value) => ({
  type: actionTypes.SET_LOADING_UNIT_ADJUSTMENT_NDC_LEVEL,
  payload: value,
});
// To dispatch plantype data
export const getPlanTypeValues = () => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      dispatch(setLoading(false));
      dispatch(dispatchPlanType(response.data));
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(dispatchPlanType([]));
    });
};
// rebate programe dispatch function
export const dispatchRebatePrograme = (data) => ({
  type: actionTypes.GET_REBATE_PROGRAM_UNIT,
  payload: data,
});

// on toggle rebate program
export const dispatchRebateProgramName = (data) => ({
  type: actionTypes.GET_REBATE_PROGRAM_NAME_UNIT,
  payload: data,
});

//  get rebate programe function
export const getRebateProgrameList = (value) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      dispatch(setLoading(false));
      return response.data;
    })
    .catch((response) => {
      dispatch(setLoading(false));
    });
};
// report selection
export const dispatchSearchScreen = (data) => ({
  type: actionTypes.SET_SEARCH_UNIT,
  payload: data,
});
// all rebate program
export const dispatchAllRebate = (data) => ({
  type: actionTypes.SET_ALL_REBATE_PROGRAM_UNIT,
  payload: data,
});
export const getAllRebateProgram = (value) => (dispatch) => {
  dispatch(dispatchAllRebate([]));
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.GET_UNIT_ADJUSTMENT_ALL_REBATE, value)
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch(dispatchAllRebate(response.data));
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(dispatchAllRebate([]));
    });
};
export const dispatchAllRebateValue = (data) => ({
  type: actionTypes.SET_ALL_REBATE_PROGRAM_VALUE_UNIT,
  payload: data,
});
// ndc grid data
export const dispatchNdcGridData = (data) => ({
  type: actionTypes.SET_NDC_GRID_DATA_UNIT,
  payload: data,
});
export const getNdcGridData = (value) => (dispatch) => {
  dispatch(setLoading(true));
  dispatch(dispatchNdcGridData([]));
  return axios
    .post(serviceEndPoint.GET_UNIT_ADJUSTMENT_GRID_DATA, value)
    .then((response) => {
      if (response.data.unitAdjustmentsNDCLevelGridReportVOList.length == 0) {
        dispatch(showNoDataMessage());
      } else {
        dispatch(dispatchNdcGridData(response.data));
      }
      dispatch(setLoading(false));
    })
    .catch((response) => {
      dispatch(dispatchNdcGridData([]));
      dispatch(setLoading(false));
    });
};
